import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './input-phone.css';

const InputPhone = ({
  defaultValue,
  onHandleChange,
  error,
  isDisabled = false,
  placeholder,
  countryCode,
}) => {
  const className = `field-holder ${error ? 'error' : ''}`;

  return (
    <div className={className}>
      <PhoneInput
        name='phone'
        type='phone'
        inputMode='numeric'
        international={true}
        value={defaultValue}
        defaultCountry={countryCode}
        disabled={isDisabled}
        onChange={(e) => onHandleChange(e)}
      />
      {placeholder && (
        <span
          className='floating-placeholder phone'
          dangerouslySetInnerHTML={{ __html: placeholder }}
        />
      )}
      {/* <span className="chevron">
        <SolidChevron size={15} color="var(--color-primary)" />
      </span> */}
      {error && error.length > 0 && <div className='error-label'>{error}</div>}
    </div>
  );
};

export default InputPhone;
